import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class OnbuyService {

  baseUrl = environment.baseUrl;


  constructor(private http:HttpClient,
    private datePipe: DatePipe,) { }
  
  get_onbuy_orders() {
    return this.http.get(this.baseUrl + '/onbuy/get_onbuy_orders');  
  }

  get_order_by_id(id) {
    return this.http.get(this.baseUrl + '/onbuy/get_order_by_id/' + id);  
  }

  update_groupon_status(order_id, FormData) {
    console.log(this.baseUrl + '/onbuy/update_onbuy_status/' + order_id);
    return this.http.post(this.baseUrl + '/onbuy/update_onbuy_status/' + order_id,{
      new_status_id: FormData.order_status_id
    });  
  }

  get_onbuy_questionnaire(order_item_id) {
    return this.http.get(this.baseUrl + '/onbuy/get_onbuy_questionnaire/' + order_item_id);  
  }



}
